import * as React from "react";

export const IconTrendDown = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_32905_107703)">
      <path d="M5.5 1.5L5.5 8.585L3.705 6.795L3 7.5L6 10.5L9 7.5L8.295 6.795L6.5 8.585L6.5 1.5L5.5 1.5Z" fill="#E57373"/>
    </g>
    <defs>
      <clipPath id="clip0_32905_107703">
        <rect width="12" height="12" fill="white" transform="translate(0 12) rotate(-90)"/>
      </clipPath>
    </defs>
  </svg>
);
